import { useTranslation } from "react-i18next";
import { FormContactsDataList } from "@/pages/ContactsPage/Components/FormContactsDataList";
import { useAppSelector } from "@/services/store";
import { currentPersonSelector } from "@/pages/ContactsPage/slice";
import { handlePeriod } from "@/shared/utils/handle-contacts-null";
import { Career, ProfessionalActivities } from "../Fields";

export const LeftSectionList = () => {
  const { t } = useTranslation();

  const currentPerson = useAppSelector(currentPersonSelector);
  if (!currentPerson) return <></>;
  return (
    <>
      <FormContactsDataList
        title={t("contactsPage.activities.professionalActivities")}
        fieldArrayName={"professionalActivities"}
        transformFieldToData={(item) => ({
          id: item?.id ?? "",
          label: item?.activity ?? "",
          subLabel: item?.industry?.name ?? "",
          value: item?.role ?? "",
        })}
        editNode={(index) => <ProfessionalActivities index={index} />}
        addableModel={{
          id: "",
          activity: "",
          personId: currentPerson?.id,
          role: "",
          industry: { name: "" },
        }}
      />
      <FormContactsDataList
        title={t("contactsPage.activities.career")}
        fieldArrayName={"careers"}
        transformFieldToData={(item) => ({
          id: item?.id ?? "",
          label: item?.company ?? "",
          value: item?.jobTitle ?? "",
          subLabel: item?.industry?.name ?? "",
          about: item?.about ?? "",
          subValue: handlePeriod(item?.careerStart, item?.careerEnd),
        })}
        editNode={(index) => <Career index={index} />}
        addableModel={{
          industry: { name: "" },
          company: "",
          personId: currentPerson?.id,
          id: "",
          careerEnd: "",
          careerStart: "",
          jobTitle: "",
          about: "",
        }}
      />
    </>
  );
};
